import { InputAdornment } from "@mui/material"

const Adornment = (props) => {
  return (
    <InputAdornment position="end">
      <div>
        {props.children}
      </div>
    </InputAdornment>
  )
}

export default Adornment